// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"MacInput_inputContainer__2d_y6","inputMacElement":"MacInput_inputMacElement__2Fcuk","divColons":"MacInput_divColons__1oPmZ"};